// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1BZ2l","form":"styles_form__KrO0h"};